"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var METASITE_ORG_MAPPING = exports.METASITE_ORG_MAPPING = false;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/restaurants-redux/dist/featureToggles.js
// module id = 973
// module chunks = 0